import { Box } from "@mui/material";
import { useTranslation } from "@localization/useTranslation";
import RiskAppetiteStatusPill from "../../riskAppetiteStatusPill/RiskAppetiteStatusPill";
import RiskReportCard from "../RiskReportCard";
import RiskReportCardCount from "../RiskReportCardCount";

interface RiskOverAppetiteCardProps {
    isLoading: boolean;
    riskAppetiteLimit: number;
    risksAboveAppetite: number;
    isExceeded: boolean;
}

function RiskOverAppetiteCard({ isLoading, riskAppetiteLimit, risksAboveAppetite, isExceeded }: RiskOverAppetiteCardProps) {
    const { translateString, translateNumber } = useTranslation();

    return (
        <RiskReportCard
            isLoading={isLoading}
            background="darkblue"
            header={translateString("riskManagementReportAppetiteLimit", { limit: translateNumber(riskAppetiteLimit) })}
        >
            <RiskReportCardCount count={risksAboveAppetite} label={translateString("riskManagementReportRisksAboveAppetite")} />

            {/* marginTop: auto pins the pill to the bottom of the card however tall the count above it renders. */}
            <Box sx={{ display: "flex", justifyContent: "center", marginTop: "auto" }}>
                <RiskAppetiteStatusPill isExceeded={isExceeded} />
            </Box>
        </RiskReportCard>
    );
}

export default RiskOverAppetiteCard;
